import LL1 from '../assets/newUI/LL1.jpeg';
import LL2 from '../assets/newUI/LL2.jpeg';
import LL3 from '../assets/newUI/LL3.jpeg';
import LL4 from '../assets/newUI/LL4.jpeg';
import LL5 from '../assets/newUI/LL5.jpeg';

import JAL1 from '../assets/newUI/JAL1.jpeg';
import JAL2 from '../assets/newUI/JAL2.jpeg';
import JAL3 from '../assets/newUI/JAL3.jpeg';
import JAL4 from '../assets/newUI/JAL4.jpeg';

import WEEKEND1 from '../assets/newUI/WEEKEND1.jpeg'
import WEEKEND2 from '../assets/newUI/WEEKEND2.jpeg'
import WEEKEND3 from '../assets/newUI/WEEKEND3.jpeg'
import WEEKEND4 from '../assets/newUI/WEEKEND4.jpeg'


// Limited Launches
export const limitedLaunches = [
  {
    url: LL1,
    alt: "Exclusive Limited Launch 1",
  },
  {
    url: LL2,
    alt: "Exclusive Limited Launch 2",
  },
  {
    url: LL3,
    alt: "Exclusive Limited Launch 3",
  },
  {
    url: LL4,
    alt: "Exclusive Limited Launch 4",
  },
  {
    url: LL5,
    alt: "Exclusive Limited Launch 5",
  },
];

// Mahagun Jal
export const mahagunJal = [
  {
    url: JAL1,
    alt: "Mahagun Jal - Scenic View 1",
  },
  {
    url: JAL2,
    alt: "Mahagun Jal - Scenic View 2",
  },
  {
    url:JAL3,
    alt: "Mahagun Jal - Scenic View 3",
  },
  {
    url: JAL4,
    alt: "Mahagun Jal - Scenic View 4",
  },
];

// Weekend Rishikesh
export const weekendRishikesh = [
  {
    url: WEEKEND1,
    alt: "Rishikesh Adventure 1",
  },
  {
    url: WEEKEND2,
    alt: "Rishikesh Adventure 2",
  },
  {
    url: WEEKEND3,
    alt: "Rishikesh Adventure 3",
  },
  {
    url: WEEKEND4,
    alt: "Rishikesh Adventure 3",
  },
];
